import React from "react";
import { useSearchParams } from "react-router-dom";
import { useIntl } from "react-intl";
import AppStore from "../../assets/images/AppStore.png";
import GooglePlay from "../../assets/images/GooglePlay.png";
import { play_store_url, app_store_url } from "../../constants";
import "./ProfileLanding.scss";

/**
 * Public fallback for the gigmiapp.com/profile universal link (GIG-25). When the app is
 * installed the OS opens it directly; otherwise the browser lands here and we prompt the
 * user to open the link on their phone or install the app. Read-only, no auth required.
 */
const ProfileLanding = () => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");

  return (
    <div className="profile-landing">
      <div className="profile-landing__card">
        <h1 className="profile-landing__title">
          {intl.formatMessage({ id: "profile_landing_title" })}
        </h1>
        <p className="profile-landing__subtitle">
          {intl.formatMessage({ id: "profile_landing_subtitle" })}
        </p>
        {type ? <p className="profile-landing__type">{type}</p> : null}
        <div className="profile-landing__badges">
          <a href={play_store_url} target="_blank" rel="noreferrer">
            <img src={GooglePlay} alt="Google Play" />
          </a>
          <a href={app_store_url} target="_blank" rel="noreferrer">
            <img src={AppStore} alt="App Store" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProfileLanding;
